/* Cart page (templates/cart.liquid) — behaviour for the Option A layout, 2026-09-06.
   · Quantity steppers change the input and submit the cart form (a full reload, as the page did
     before): the wholesale-pricing script and every total re-render from Liquid, so B2B prices,
     add-on lines and Shopify discounts always agree.
   · A linked product's add-ons, listed in its card, follow its quantity; Remove on one add-on takes
     out that line alone (the card's own Remove is a link that empties every line of the card).
   · Clear cart asks inline before going to /cart/clear.
   · "Estimate" in the summary opens the theme's shipping calculator under the summary card.
   · "Talk to a specialist" opens Gorgias chat when it is on the page, else the contact page.
   · On phones (< 993px) a slim bar with the total and Checkout is fixed to the bottom while the
     blue summary card is off screen. */
(function () {
  'use strict';
  var form = document.getElementById('dmc-form');

  /* A linked product's add-on lines keep a hidden quantity field each, in their place among the form's
     lines and marked with their main product's link (templates/cart.liquid). Copying the main product's
     quantity onto them before submitting moves the add-ons with it in the same update, and 0 takes
     them out with it. */
  function syncAddOnLines() {
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-dmc-add-on-of]'));
    Array.prototype.forEach.call(form.querySelectorAll('.dmc__item[data-dmc-link]'), function (card) {
      var input = card.querySelector('.dmc__qty-input');
      var link = card.getAttribute('data-dmc-link');
      if (!input) { return; }
      fields.forEach(function (field) {
        if (field.getAttribute('data-dmc-add-on-of') === link) { field.value = input.value; }
      });
    });
  }

  function submitForm() {
    if (!form) { return; }
    syncAddOnLines();
    form.classList.add('is-busy');
    if (typeof form.requestSubmit === 'function') { form.requestSubmit(); } else { form.submit(); }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }
    var btn = e.target.closest('[data-dmc-step]');
    if (!btn) { return; }
    var input = btn.parentNode.querySelector('.dmc__qty-input');
    if (!input) { return; }
    var v = parseInt(input.value, 10);
    if (isNaN(v)) { v = 0; }
    v = Math.max(0, v + parseInt(btn.getAttribute('data-dmc-step'), 10));
    input.value = String(v);
    submitForm();
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('dmc__qty-input')) { return; }
    var v = parseInt(String(t.value).replace(/[^0-9]/g, ''), 10);
    if (isNaN(v) || v < 0) { v = 0; }
    t.value = String(v);
    submitForm();
  });

  /* Remove on an add-on takes out that line alone, then drops it from its main product's "Add-ons" note,
     which lists the add-ons on the order; the others keep their order there. Lines are changed by key,
     since changing a note can move its line. Without this script the link removes the line alone. */
  function postCart(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) { throw new Error(url + ' ' + r.status); } return r.json(); });
  }
  // as the product page names an add-on in that note: its product, and its variant when it has several
  function addOnName(item) { return item.product_title + (item.variant_title ? ' \u2013 ' + item.variant_title : ''); }
  function dropFromAddOnsNote(cart, mainKey) {
    var main = cart.items.filter(function (item) { return item.key === mainKey; })[0];
    var notes = main && main.properties;
    if (!notes || !notes['Add-ons']) { return null; }
    var before = notes['Add-ons'];
    var place = function (name) { var at = before.indexOf(name); return at < 0 ? before.length : at; };
    var names = cart.items.filter(function (item) {
      return item.properties && item.properties.For && item.properties._add_on_link === notes._add_on_link;
    }).map(addOnName).sort(function (a, b) { return place(a) - place(b); });
    var after = {};
    Object.keys(notes).forEach(function (key) { if (key !== 'Add-ons') { after[key] = notes[key]; } });
    if (names.length) { after['Add-ons'] = names.join(', '); }
    if (after['Add-ons'] === before) { return null; }
    return postCart('/cart/change.js', { id: mainKey, quantity: main.quantity, properties: after });
  }
  document.addEventListener('click', function (e) {
    var remove = e.target.closest && e.target.closest('[data-dmc-remove-add-on]');
    if (!remove || !form || !window.fetch) { return; }
    var mainKey = remove.closest('.dmc__item').getAttribute('data-key');
    e.preventDefault();
    form.classList.add('is-busy');
    postCart('/cart/change.js', { id: remove.getAttribute('data-key'), quantity: 0 }).then(function (cart) {
      return Promise.resolve().then(function () { return dropFromAddOnsNote(cart, mainKey); }).catch(function () {}).then(function () { window.location.reload(); });
    }, function () {
      window.location.href = remove.href;
    });
  });

  /* clear cart — inline confirm */
  var clearBtn = document.querySelector('[data-dmc-clear]');
  var confirmRow = document.querySelector('[data-dmc-confirm]');
  if (clearBtn && confirmRow) {
    clearBtn.addEventListener('click', function () {
      clearBtn.hidden = true;
      confirmRow.hidden = false;
      var yes = confirmRow.querySelector('[data-dmc-yes]');
      if (yes) { yes.focus(); }
    });
    confirmRow.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-dmc-keep]')) {
        confirmRow.hidden = true;
        clearBtn.hidden = false;
        clearBtn.focus();
      }
    });
  }

  /* estimate shipping — toggle the calculator under the summary card */
  Array.prototype.forEach.call(document.querySelectorAll('[data-dmc-estimate]'), function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var panel = document.getElementById('dmc-estimate');
      if (!panel) { return; }
      panel.hidden = !panel.hidden;
      link.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      if (!panel.hidden) {
        // no field focus here: on iOS that would pop the country picker open
        try { panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (err) {}
      }
    });
  });

  /* "Use my current location": device position → country / state / ZIP → run the rate lookup.
     Reverse geocoding uses BigDataCloud's keyless client endpoint, with Nominatim as a fallback. */
  var COUNTRY_NAMES = { US: 'United States', CA: 'Canada', GB: 'United Kingdom', MX: 'Mexico', AU: 'Australia' };
  function setSelect(sel, wanted) {
    if (!sel || !wanted) { return false; }
    var w = String(wanted).toLowerCase();
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (o.value.toLowerCase() === w || o.text.toLowerCase() === w) { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); return true; }
    }
    return false;
  }
  function fillAddress(a) {
    var country = document.getElementById('address_country');
    var province = document.getElementById('address_province');
    var zip = document.getElementById('address_zip');
    var name = COUNTRY_NAMES[a.countryCode] || a.countryName;
    var ok = setSelect(country, name) || setSelect(country, a.countryName);
    if (ok && province) { setSelect(province, a.state); }
    if (zip && a.postcode) { zip.value = a.postcode; }
    return ok;
  }
  function reverseGeocode(lat, lon) {
    var primary = 'https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=' + lat + '&longitude=' + lon + '&localityLanguage=en';
    return fetch(primary).then(function (r) { return r.json(); }).then(function (j) {
      return { countryCode: j.countryCode, countryName: j.countryName, state: j.principalSubdivision, postcode: j.postcode };
    }).catch(function () {
      var alt = 'https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=' + lat + '&lon=' + lon;
      return fetch(alt, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
        var ad = j.address || {};
        return { countryCode: (ad.country_code || '').toUpperCase(), countryName: ad.country, state: ad.state, postcode: ad.postcode };
      });
    });
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-dmc-locate]'), function (btn) {
    var status = document.querySelector('[data-dmc-locate-status]');
    function say(msg, isError) { if (!status) { return; } status.textContent = msg; status.hidden = !msg; status.classList.toggle('is-error', !!isError); }
    btn.addEventListener('click', function () {
      if (!navigator.geolocation) { say('Location is not available in this browser — enter your ZIP instead.', true); return; }
      btn.disabled = true;
      say('Finding your location…');
      navigator.geolocation.getCurrentPosition(function (pos) {
        reverseGeocode(pos.coords.latitude, pos.coords.longitude).then(function (a) {
          if (fillAddress(a)) {
            say('');
            var go = document.querySelector('.dmc__estimate .get-rates');
            if (go) { go.click(); }
          } else {
            say('We could not match your location to an address — enter your ZIP instead.', true);
          }
        }).catch(function () {
          say('We could not look up your location — enter your ZIP instead.', true);
        }).then(function () { btn.disabled = false; });
      }, function (err) {
        btn.disabled = false;
        say(err && err.code === 1 ? 'Location access was declined — enter your ZIP instead.' : 'We could not get your location — enter your ZIP instead.', true);
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
    });
  });
  window.__dmcFillAddress = fillAddress; // used for testing the form fill without a device position

  /* default the country to United States if nothing else selected it (most customers) */
  window.addEventListener('load', function () {
    var c = document.getElementById('address_country');
    if (c && !c.value) { setSelect(c, 'United States'); }
  });

  /* chat */
  Array.prototype.forEach.call(document.querySelectorAll('[data-dmc-chat]'), function (a) {
    a.addEventListener('click', function (e) {
      var g = window.GorgiasChat;
      if (g && typeof g.open === 'function') { e.preventDefault(); g.open(); }
    });
  });

  /* delivery ETA — same maths as the product page: "3 days - 5 days" → business days from today */
  function extractNumbers(s) { var m = String(s || '').match(/\d+/g); return m ? m.map(Number) : []; }
  function bizDaysAhead(base, n) {
    var t = base.getTime(), count = 0;
    while (count < n) { t += 864e5; var d = new Date(t).getDay(); if (d !== 0 && d !== 6) { count++; } }
    return new Date(t);
  }
  function fmtDate(d, withYear) {
    var opts = withYear ? { month: 'short', day: 'numeric', year: 'numeric' } : { month: 'short', day: 'numeric' };
    try { return d.toLocaleDateString('en-US', opts); } catch (e) { return d.toDateString(); }
  }
  (function () {
    var now = new Date();
    Array.prototype.forEach.call(document.querySelectorAll('.dmc__eta'), function (el) {
      if (el.getAttribute('data-backordered') === 'true') { return; }
      var eta = el.getAttribute('data-eta');
      var slot = el.querySelector('[data-dmc-eta-date]');
      if (!eta || !slot) { return; }
      var nums = extractNumbers(eta);
      if (!nums.length) { return; }
      var min = nums[0], max = nums.length > 1 ? nums[1] : nums[0];
      var dMin = bizDaysAhead(now, min), dMax = bizDaysAhead(now, max);
      var withYear = dMax.getFullYear() !== now.getFullYear();
      slot.textContent = (fmtDate(dMin, withYear) === fmtDate(dMax, withYear)) ? fmtDate(dMin, withYear) : fmtDate(dMin, withYear) + ' – ' + fmtDate(dMax, withYear);
    });
  })();

  /* phone sticky bar */
  var bar = document.querySelector('.dmc__stickybar');
  var summary = document.getElementById('dmc-summary');
  if (bar && summary) {
    document.body.classList.add('dmc-has-bar');
    // initial state without waiting for the observer's first callback
    // html.dmc-bar-on lifts the apps' corner buttons (chat, rewards, Klaviyo's tab) above the bar while it shows
    // (assets/cart-page.css), as html.dmp-bar-on does for the product page's bar
    var showBar = function (on) {
      bar.classList.toggle('is-shown', on);
      document.documentElement.classList.toggle('dmc-bar-on', on);
    };
    var rect = summary.getBoundingClientRect();
    var onScreen = rect.bottom > 0 && rect.top < window.innerHeight;
    showBar(!onScreen);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        showBar(!entries[0].isIntersecting);
      }, { threshold: 0.15 });
      io.observe(summary);
    } else {
      showBar(true);
    }
  }
})();
